// 共通化ドロワー
import { ref } from "vue";
import { useRoute } from "vue-router";

export function useDrawer() {
  const drawer = ref(null);
  const route = useRoute();

  const toggleDrawer = () => {
    drawer.value = !drawer.value;
  };

  const handleNavClick = (item) => {
    // 現在のページをクリックしたときだけDrawerを閉じる
    if (route.path === item.to) drawer.value = false;
  };

  return {
    drawer,
    toggleDrawer,
    handleNavClick,
  };
}
